import React, { useContext, useEffect, useState } from "react";
import { formatText, formatDate } from "../Utils";
import { LoadingContext } from "../Context";
import { MyEventsType } from "../Structures/Types";
import { ProfileLayout } from "../Container/Layout";
import { TransactionGetMyEvents } from "../Services/Transactions";
import { Empty, Tag } from "../Components/Base";
import { Link } from "react-router-dom";

const MyEvents = () => {
  const { loading, setLoading } = useContext(LoadingContext);

  // ===========================================================================

  const [myEventsList, setMyEventsList] = useState<MyEventsType[]>([]);

  // ===========================================================================

  useEffect(() => {
    setLoading(true);
    TransactionGetMyEvents()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          setMyEventsList(res.data || []);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  // ===========================================================================

  return (
    <ProfileLayout>
      <Empty
        data={myEventsList}
        isLoading={loading}
        description="تاکنون در رویدادی ثبت نام نکرده اید"
      >
        <div className="container">
          <div className="row">
            {myEventsList.map((event) => (
              <div key={event.id} className="col-sm-6">
                <Link
                  to={`/events/${event.event.id}`}
                  className="card border border-1"
                >
                  <div className="position-relative" style={{ height: 200 }}>
                    <img
                      className="card-img h-100 w-100 object-fit-cover"
                      src={event.event.thumbnail}
                      alt={event.event.title}
                    />
                    <div className="card-img-overlay d-flex align-items-start flex-column p-3">
                      <div className="w-100 mt-auto">
                        {event.event.categories.map((tag) => (
                          <Tag key={tag.id} tag={tag} />
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="card-body px-2 pt-3">
                    <h4 className="card-title">
                      <span className="btn-link text-reset fw-bold">
                        {event.event.title}
                      </span>
                    </h4>
                    <p className="card-text">
                      {formatText(event.event.description, 70)}
                    </p>

                    <ul className="nav nav-divider align-items-center d-none d-sm-inline-block">
                      <li className="nav-item">
                        تاریخ:‌ {formatDate(event.event.date)}
                      </li>
                      <span className="fw-bolder mx-2">-</span>
                      <li className="nav-item">ساعت: {event.event.time}</li>
                    </ul>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </Empty>
    </ProfileLayout>
  );
};

export default MyEvents;
